export default "__VITE_ASSET__e180d191__"